import React from 'react';
import { Filter, ReferenceInput, SelectInput } from 'react-admin';
import { CustomDateInput } from '../../../../commonComponents/CustomDateInput';
import UserAutocompleteInput from '../../../../commonComponents/UserAutocompleteInput';

const LepReportsFilter = (props) => (
  <Filter {...props}>
    <ReferenceInput label="LEP" source="competition_id" reference="admin/lep" alwaysOn>
      <SelectInput optionText={(s) => `(${s.id}) ${s.name}`} />
    </ReferenceInput>
    <UserAutocompleteInput label="User ID" source="user_id" reference="admin/users/autocomplete" alwaysOn />
    <CustomDateInput label="Choose start date" source="start_date" start alwaysOn />
    <CustomDateInput label="Choose end date (12:00)" source="end_date" end alwaysOn />
  </Filter>
);

export default LepReportsFilter;
